export default "__VITE_ASSET__ByvkmwAZ__"